module.exports = __webpack_public_path__ + "img/project-management.d1883d47.jpg";